import { Box, colors } from '@fortum/elemental-ui';

const Divider = () => {
  return (
    <Box
      backgroundColor={colors.emperorGrey}
      border="1px solid #555555"
      height="1px"
      width="100%"
      opacity={0.2}
      data-testid="divider"
    />
  );
};

export default Divider;
